import React, {Component} from 'react';
import styles from './App.css';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faAt, faCheck, faEnvelope, faHandshake, faIndustry, faPhone, faTree, faTruckMoving} from '@fortawesome/free-solid-svg-icons';
import About from "./components/About/About";
import Title from "./components/Title/Title";
import Production from "./components/Production/Production";
import Transport from "./components/Transport/Transport";
import Cooperation from "./components/Cooperation/Cooperation";
import Contact from "./components/Contact/Contact";
import MainGraphics from "./components/MainGraphics/MainGraphics";

library.add(faTree, faIndustry, faCheck, faHandshake, faEnvelope, faAt, faPhone);

class App extends Component {
    render() {
        return (
            <div>
                <Title/>
                <div className={styles.desktopFlexWrap}>
                    <div className={styles.desktopColumns}>
                        <About icon={faTree} iconChecked={faCheck}/>
                        <Cooperation icon={faHandshake}/>
                    </div>
                    <div className={styles.desktopColumns}>
                        <MainGraphics/>
                        <Contact icon={faEnvelope} iconMail={faAt} iconPhone={faPhone}/>
                    </div>
                    <div className={styles.desktopColumns}>
                        <Production icon={faIndustry}/>
                        <Transport icon={faTruckMoving}/>
                    </div>
                </div>
            </div>

        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js